import React, { Component, Fragment } from 'react';
import Sidebar from '../navigation/Sidebar';
import Rest from "../../services/Rest";
import { withRouter } from "react-router-dom";
import Modal from "../Modal";
import SweetAlert from 'react-bootstrap-sweetalert';
class Users extends Component {

    constructor(props) {
        super(props);
        this.Rest = new Rest();
        this.datauser = JSON.parse(localStorage.getItem("ls")) || [];
    }

    state = {
        usuarios: [],
        error: false,
        messageError: "",
        success: false,
        messageSuccess: "",
        modalOptions: {
            show: "",
            uid: 0,
            saldo: "",
            uindex: 0,
            comentario: ""
        },
        showSweet: false,
        id_eliminar: 0,
        busqueda: ""
    }

    obtenerUsuarios = async () => {
        this.Rest.get("usuarios", this.datauser)
            .then(usuarios => {
                if (usuarios.status === 200) {
                    this.setState({
                        usuarios: usuarios.data
                    })
                }
                else {
                    if (usuarios.status === 404) {
                        localStorage.removeItem("ls");
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: usuarios.message
                        })
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    messageError: err
                })
            })
    }

    componentDidMount() {
        this.obtenerUsuarios();

    }

    editarUsuario(id) {
        this.props.history.push("/editar-usuario/" + id)
    }

    eliminarUsuario() {
        const id = this.state.id_eliminar;
        const usuarios = [...this.state.usuarios];
        this.Rest.delete("usuarios/" + id, this.datauser)
            .then(response => {
                if (response.status === 200) {
                    const _us = usuarios.filter(_u => _u.uid !== id);
                    this.setState({
                        success: true,
                        messageSuccess: "Usuario ha sido eliminado"
                    });
                    this.setState({
                        usuarios: _us
                    })
                }
                else {
                    if (response.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: response.message
                        })
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    messageError: "Error: " + err
                });
            })
        this.setState({
            showSweet: false,
            id_eliminar: 0
        })
    }


    handleCheck = e => {
        e.persist();
        this.Rest.post(this.state.usuarios[e.target.dataset.id], 'estado_usuario', 'estatus', this.datauser)
            .then(resp => {
                if (resp.status === 200) {
                    this.setState({
                        error: false,
                        errorMessage: ""
                    }, () => {
                        let usuarios = [...this.state.usuarios]
                        usuarios[e.target.dataset.id]['bloqueo'] = resp.data.estatus
                        this.setState({
                            usuarios
                        })
                    })
                }
                else {
                    if (resp.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            errorMessage: resp.message
                        })
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    errorMessage: "Error de respuesta del servidor."
                })
            })
    }



    dismiss() {
        this.setState({
            error: false,
            success: false,
            messageError: "",
            messageSuccess: ""
        })
    }


    handleChanges = e => {
        this.setState({
            modalOptions: {
                ...this.state.modalOptions,
                [e.target.name]: e.target.value
            }
        })
    }

    abrirModal = (u, i) => {
        this.setState({
            modalOptions: {
                show: "show",
                uid: u.uid,
                saldo: "",
                uindex: i,
                comentario: ""
            }
        })
    }

    cerrarModal = e => {
        this.setState({
            modalOptions: {
                show: "",
                uid: null,
                saldo: "",
                uindex: null
            }
        })
    }
    guardarSaldo = e => {
        e.persist();
        //{show: "show", uid: "43", saldo: "2000"}
        this.Rest.post(this.state.modalOptions, 'usuarios/saldos', 'usuario', this.datauser)
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        error: false,
                        success: true,
                        messageSuccess: "Saldo actualizado."
                    }, () => {
                        let usuarios = [...this.state.usuarios]
                        usuarios[this.state.modalOptions.uindex]['saldo'] = response.data
                        this.setState({
                            usuarios,
                            modalOptions: {
                                show: "",
                                uid: null,
                                saldo: "",
                                uindex: null
                            }
                        })

                    })
                }
                else {
                    if (response.status === 404) {
                        localStorage.removeItem("ls");
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            success: false,
                            error: true,
                            messageError: response.message
                        })
                    }
                }
            })
            .catch(err => {
                this.setState({
                    success: false,
                    error: true,
                    messageError: "Error de respuesta del servidor"
                })
            })
    }


    showSweet(id) {
        this.setState({
            showSweet: true,
            id_eliminar: id
        })
    }

    buscar(event) {
        this.setState({
            busqueda: event.target.value.substr(0, 20)
        })
    }

    limpiar() {
        this.setState({
            busqueda: ""
        })
    }



    render() {
        const { error, messageError, success, messageSuccess, usuarios } = this.state;

        return (
            <Fragment>

                <div className="wrapper">
                    <Sidebar logout={() => this.props.callBackLogout()} />
                    <div id="content">
                        <div className="container">

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="dashboard-panel">
                                        <h4 className="mb-center">Lista de usuarios</h4>

                                        <div className="d-flex">
                                            <div>

                                            </div>
                                            <div className="ml-auto">
                                                <ul className="list-inline">
                                                    <li className="list-inline-item">
                                                        <div className="c">
                                                            <div className="c-header">Usuarios</div>
                                                            <div className="c-body">
                                                                <span>
                                                                    {usuarios.length}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>



                                        <div className="table-responsive">
                                            <table className="table table-condensed table-bordered table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>Usuario</th>
                                                        <th>Nombre</th>
                                                        <th>IP</th>
                                                        <th>Estado API</th>
                                                        <th>Precio por mensaje</th>
                                                        <th>Crédito</th>
                                                        <th>Estado del usuario</th>
                                                        <th>Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        usuarios.length > 0 ?
                                                            usuarios.map((_us, index) => (
                                                                <tr key={_us.uid}>
                                                                    <td>{_us.usuario}</td>
                                                                    <td>{_us.nombre} {_us.apellidos}</td>
                                                                    <td>{_us.ip}</td>
                                                                    <td>
                                                                        {_us.habilitar === "1" ? <span className="badge badge-pill badge-success">Habilitada</span> : <span className="badge badge-pill badge-danger">Inhabilitada</span>}
                                                                    </td>
                                                                    <td>${_us.precio !== null ? _us.precio : 0}</td>
                                                                    <td className="saldo">
                                                                        ${_us.saldo}
                                                                    </td>
                                                                    <td>

                                                                        <div className="custom-control custom-switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="custom-control-input"
                                                                                id={"bloqueo" + index}
                                                                                name={"bloqueo" + index}
                                                                                data-id={index}
                                                                                value={this.state.usuarios[index].bloqueo}
                                                                                onChange={this.handleCheck}
                                                                                defaultChecked={_us.bloqueo === "0" ? "checked" : ""} />
                                                                            <label className="custom-control-label" htmlFor={"bloqueo" + index}></label>
                                                                        </div>

                                                                    </td>
                                                                    <td>
                                                                        <div className="btn-group" role="group" aria-label="Basic example">
                                                                            <button type="button" className="btn btn-success"
                                                                                onClick={() => this.abrirModal(_us, index)}>
                                                                                <i className="fas fa-dollar-sign"></i>
                                                                            </button>
                                                                            <button type="button" className="btn btn-primary"
                                                                                onClick={() => this.editarUsuario(_us.uid)}>
                                                                                <i className="fas fa-pencil-alt"></i>
                                                                            </button>
                                                                            <button type="button" className="btn btn-danger"
                                                                                onClick={() => this.showSweet(_us.uid)}>
                                                                                <i className="fas fa-times"></i>
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                            :
                                                            <tr>
                                                                <td colSpan="8">
                                                                    <div className="alert alert-info">
                                                                        <strong>No existen usuarios en el sistema</strong>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        {error ?
                                            <div className="alert alert-danger alert-float">
                                                <button type="button" className="close" onClick={() => this.dismiss()}>
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                                {messageError}
                                            </div> : null}
                                        {success ?
                                            <div className="alert alert-success alert-float">
                                                <button type="button" className="close" onClick={() => this.dismiss()}>
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                                {messageSuccess}
                                            </div> : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    options={this.state.modalOptions}
                    cerrarModal={() => this.cerrarModal}
                    guardarSaldo={() => this.guardarSaldo}
                    handleChanges={() => this.handleChanges} />


                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Sí"
                    confirmBtnBsStyle="danger"
                    cancelBtnText="Cancelar"
                    cancelBtnBsStyle="primary"
                    show={this.state.showSweet}
                    title="¿Realmente deseas eliminar a este usuario?"
                    onCancel={() => this.setState({ showSweet: false })}
                    onConfirm={() => {
                        this.eliminarUsuario();
                    }}
                />


            </Fragment>
        );
    }
}

export default withRouter(Users);


// WEBPACK FOOTER //
// ./src/components/users/Users.js